import React, { ChangeEvent } from 'react'

import dayjs from 'dayjs'
import styled from 'styled-components'

import { useCupons } from '../../context'
import { Profesor, Student } from '../../types'

export const SelectComponent = styled.select`
  border-radius: 10px;
  border: 1px solid #fdfdfd;
  background: #fafafa;

  color: #8e92bc;
  padding: 10px 12px;
  width: 100%;
  color: #8e92bc;
  border: 1px solid #dbdbdb;
  outline: none;

  .bolder {
    font-weight: 500;
  }

  &.active {
    border: 1px solid #08a8d2;
    color: #0a0a18;
  }
  &:hover,
  &:focus {
    border: 1px solid #08a8d2;
    color: #0a0a18;
  }
`

const Select = ({
  list,
  value,
  name,
  defaultValue,
  showActiveBonus = false,
  handleSelectChange,
}: {
  list: Student[] | Profesor[]
  value?: string
  name: string
  defaultValue: string
  showActiveBonus?: boolean
  handleSelectChange: (e: ChangeEvent<HTMLSelectElement>) => void
}) => {
  const { cupons } = useCupons()
  const now = dayjs()
  const isStudent = (item: Student | Profesor): item is Student => {
    return (item as Student).hasActiveBonus !== undefined
  }

  const studentOpt = (item: Student) => {
    const {
      name,
      lastname,
      uid,
      activeBonus,
      hasActiveBonus,
      currentAmountOfClasses,
      currentAttendance,
    } = item as Student
    const cupon = cupons.find((cupon) => cupon.uid === activeBonus)

    const showMessage =
      (!hasActiveBonus &&
        dayjs(cupon?.dueDate).isBefore(now) &&
        currentAmountOfClasses > currentAttendance) ||
      (hasActiveBonus && currentAmountOfClasses > currentAttendance)
        ? true
        : false

    return (
      <option key={uid} value={uid}>
        {name} {lastname}{' '}
        {showActiveBonus && showMessage && (
          <>
            - Tiene un bono{' '}
            {dayjs(cupon?.dueDate).isAfter(now) ? 'ACTIVO' : 'VENCIDO'} con{' '}
            {currentAmountOfClasses - currentAttendance} clases restantes
          </>
        )}
      </option>
    )
  }

  return (
    <SelectComponent
      value={value}
      onChange={handleSelectChange}
      name={name}
      className="modalDropdown"
    >
      <option value="">{defaultValue}</option>
      {list &&
        list.map((item) => {
          if (isStudent(item)) {
            return studentOpt(item)
          } else {
            return (
              <option key={item.uid} value={item.uid}>
                {item.name} {item.lastname}
              </option>
            )
          }
        })}
    </SelectComponent>
  )
}

export default Select
